import { generate } from "shortid";
import { PAGE_THEMES } from "../../types";

export const REFERRER_PAYMENT_PAGES = {
  partner_payment_setup_account_page: {
    id: `partner_payment_setup_account_page-${generate()}`,
    type: "partner_payment_setup_account_type",
    backwards_navigation_enabled: true,
    title: null,
    has_header_arch: true,
    module_name: "web_payment",
    target_state: "welcome_data",
    target_field: null,
    theme: PAGE_THEMES.LIGHT,
    target_pages: [
      {
        name: "web_payment_download_page",
        data_key: "description",
        action: (data) => {
          return data;
        },
      },
    ],
    data: {
      title: null,
      description: null,
      image: null,
      options: [],
      custom_back: null,
      default_progression: "partner_onboarding_payment__select_plan_page",
    },
  },
  partner_onboarding_payment__select_plan_page: {
    id: `partner_onboarding_payment__select_plan_page-${generate()}`,
    type: "partner_onboarding_payment_select_plan_type",
    backwards_navigation_enabled: true,
    title: null,
    module_name: "partner_payment",
    target_state: "welcome_data",
    target_field: "email",
    theme: PAGE_THEMES.LIGHT,
    target_pages: [
      {
        name: "web_payment_download_page",
        data_key: "description",
        action: (data) => {
          return data;
        },
      },
    ],
    data: {
      title: null,
      description: null,
      image: null,
      default_progression: "partner_onboarding_payment__delivery_page",
      options: [],
    },
  },
  partner_onboarding_payment__delivery_page: {
    id: `partner_onboarding_payment__delivery_page-${generate()}`,
    type: "partner_onboarding_payment_delivery_type",
    backwards_navigation_enabled: true,
    title: null,
    module_name: "partner_payment",
    target_state: "welcome_data",
    target_field: null,
    target_pages: [],
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: null,
      description: null,
      image: null,
      default_progression: "web_payment_success_page",
      options: [],
    },
  },
};
